module.exports = __webpack_public_path__ + "static/soehne-web-kraftig-e12358fe307a3bc6b51fea7923dfa1fc.woff2";